export const FORMS_RESET = 'FORMS_RESET';
export const FORMS_REQUEST = 'FORMS_REQUEST';
export const FORMS_SUCCESS = 'FORMS_SUCCESS';
export const FORMS_FAILURE = 'FORMS_FAILURE';
